import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { RecentUploadsService } from '../services/recent-uploads.service';
import { TranslocoService } from '@jsverse/transloco';

export const pendingUploadGuard: CanDeactivateFn<unknown> = (component, currentRoute, currentState, nextState) => {
  const recentUploads = inject(RecentUploadsService);
  const transloco = inject(TranslocoService);

  const hasPending = recentUploads.hasPendingUploads();

  if (!hasPending) return true;

  const message = transloco.translate('shared.leave_upload_prompt');

  const result = window.confirm(message);

  if (result) {
    recentUploads.cleanup();
  }

  return result;
};
